import { FlowTileBody, FlowTileDetail } from './tiles/FlowTile';
import { ProgressTileBody, ProgressTileDetail } from './tiles/ProgressTile';
import { RagTileBody, RagTileDetail } from './tiles/RagTile';
import { CostTileBody, CostTileDetail } from './tiles/CostTile';
import { FeedTileBody, FeedTileDetail } from './tiles/FeedTile';
import { ScheduleTileBody, ScheduleTileDetail } from './tiles/ScheduleTile';
import { ChatTileBody, ChatTileDetail } from './tiles/ChatTile';

// The dashboard's tiles in render order (#1157–#1160,
// specs/workshop-dashboard.md). A tile reads its slice of the one shared
// payload via useDashboardData(); only the RAG tile fetches its own layout
// data (the v4 map, too heavy for the aggregate payload).
//
// labelKey is not rendered on the tile (tiles are self-explanatory by
// decision); it is the aria-label and the detail overlay's heading. A tile
// with `route` navigates there on tap instead of opening an overlay.
export const DASHBOARD_TILES = [
  // schedule is registered but hidden from the shell for now — the left
  // bar's timer covers it (adjustment 2026-10-19); revisit with room feedback.
  { key: 'schedule', labelKey: 'dashboard.tiles.schedule', dataKey: 'schedule', Tile: ScheduleTileBody, Detail: ScheduleTileDetail },
  { key: 'flow', labelKey: 'dashboard.tiles.flow', dataKey: 'flow', Tile: FlowTileBody, Detail: FlowTileDetail },
  { key: 'progress', labelKey: 'dashboard.tiles.progress', dataKey: 'moduleSummary', Tile: ProgressTileBody, Detail: ProgressTileDetail },
  // The overlay embeds the interactive corpus visualizer, chrome-free
  { key: 'rag', labelKey: 'dashboard.tiles.rag', dataKey: 'rag', Tile: RagTileBody, Detail: RagTileDetail },
  { key: 'cost', labelKey: 'dashboard.tiles.cost', dataKey: 'cost', Tile: CostTileBody, Detail: CostTileDetail },
  { key: 'feed', labelKey: 'dashboard.tiles.feed', dataKey: 'activity', Tile: FeedTileBody, Detail: FeedTileDetail },
  { key: 'chat', labelKey: 'dashboard.tiles.chat', dataKey: 'chat', Tile: ChatTileBody, Detail: ChatTileDetail },
];

export function tileByKey(key) {
  return DASHBOARD_TILES.find((tile) => tile.key === key);
}

// Layout (shell decision 2026-10-19): a left bar — phase menu in the corner,
// schedule under it, the flow bar scrolling below — then progress alone on
// the top row and the remaining four tiles on the bottom row.
export const BOTTOM_ROW_KEYS = ['rag', 'cost', 'feed', 'chat'];
